module.exports = __webpack_public_path__ + "img/f326993.png";